import { Pipe, PipeTransform } from '@angular/core';
import { EventStatus, League } from '@model';

@Pipe({
    name: 'leagueEventsToGo',
    standalone: false
})
export class LeagueEventsToGoPipe implements PipeTransform {
  transform = (value?: League): number => 0;

}
